import {
  Directive,
  Input,
  OnChanges,
  SimpleChanges,
  ElementRef,
} from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  ValidationErrors,
  Validator,
  ValidatorFn,
} from '@angular/forms';

@Directive({
  selector: '[appEmailValidator]',
  standalone: true,
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: EmailValidatorDirective,
      multi: true,
    },
  ],
})
export class EmailValidatorDirective implements Validator, OnChanges {
  @Input('appEmailValidator') shouldValidate: boolean = true;

  private validator: any;
  private onChange: () => void = () => {};

  constructor(private el: ElementRef) {
    this.validator = EmailValidatorDirective.emailValidator();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['shouldValidate']) {
      this.onChange();
    }
  }

  validate(control: AbstractControl): ValidationErrors | null {
    if (this.shouldValidate) {
      return this.validator(control);
    } else {
      return null;
    }
  }

  registerOnValidatorChange(fn: () => void): void {
    this.onChange = fn;
  }

  static emailValidator(): ValidatorFn {
    const emailRegex =
      /^[a-zA-Z0-9_+-]+(\.[a-zA-Z0-9_+-]+)*@([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null;
      }
      const isValid = emailRegex.test(control.value);
      return isValid ? null : { email: { valid: false } };
    };
  }
}
